import { Text, Typeahead } from "@merge-api/merge-javascript-shared";
import { DiffCategoryTypes } from "../../entities";
import { ReactElement, SyntheticEvent, MouseEvent, KeyboardEvent, FocusEvent } from "react";

interface ModelDifferenceTypeaheadProps {
  onChange: (value: DiffCategoryTypes | null) => void;
  selectedValue: DiffCategoryTypes | null;
}

const ModelDifferenceTypeahead = ({ onChange, selectedValue }: ModelDifferenceTypeaheadProps) => {
  // Helper function to get display name for enum
  const getDisplayName = (value: DiffCategoryTypes): string => {
    const displayNameMap: Record<DiffCategoryTypes, string> = {
      [DiffCategoryTypes.SAME]: "Same",
      [DiffCategoryTypes.DIFFERENT]: "Different",
      [DiffCategoryTypes.NET_NEW]: "New",
      [DiffCategoryTypes.NET_MISSING]: "Deleted",
    };

    return displayNameMap[value];
  };

  // Const derived from enum
  const options = Object.values(DiffCategoryTypes);

  // Function to handle typeahead change
  const handleTypeaheadChange = (
    _event:
      | SyntheticEvent<Element, Event>
      | MouseEvent<Element, MouseEvent>
      | KeyboardEvent<Element>
      | FocusEvent<Element>
      | null,
    newSelectedOption: DiffCategoryTypes | null
  ) => {
    onChange(newSelectedOption);
  };

  // Function to render option
  const renderOption = (option: DiffCategoryTypes): ReactElement => {
    return <Text>{getDisplayName(option)}</Text>;
  };

  return (
    <div>
      <Text as="div" variant="h6" className="mb-2">
        Model difference type
      </Text>
      <Typeahead
        onChange={handleTypeaheadChange}
        options={options}
        value={selectedValue}
        getOptionLabel={getDisplayName}
        renderOption={renderOption}
        placeholder="All types"
      />
    </div>
  );
};

export default ModelDifferenceTypeahead;
